<template lang="pug">
.app-root
  Logo
  main#main
    template(v-if="!isLoggingIn")
      LoginView(v-if="!isLoggedIn")
      ConsentView(v-else @consent="login")
    Spinner(v-else)
  TransitionGroup.alerts-group.is-bottom.is-right(name="alerts" tag="div")
    Alert(v-for="alert in alerts" :key="alert.id" :message="alert.message" :type="alert.type")

</template>

<script>
import LoginView from '@/components/LoginView';
import ConsentView from '@/components/ConsentView';
import Alert from '@/components/Alert';
import Spinner from '@/components/Spinner';
import Logo from '@/components/Logo';
import Store from './store';

export default {
  name: 'App',
  components: {
    LoginView,
    ConsentView,
    Alert,
    Logo,
    Spinner
  },
  data: () => ({
    alerts: Store.alerts
  }),
  computed: {
    isLoggedIn () {
      return Store.isLoggedIn;
    },
    isLoggingIn () {
      return Store.isLoggingIn;
    }
  },
  methods: {
    login () {
      if (window.opener) {
        window.opener.postMessage({ token: Store.token }, '*');
      }
    }
  }
};
</script>

<style lang="stylus">
.alerts-group
  display: flex
  flex-direction: column
  position: fixed
  max-width: 30vw
  margin: 10px 20px
  z-index: 99999

  +mq($until: 'desktop')
    max-width: 60vw

  +mq($until: 'mobile')
    max-width: 100%

  &.is-top
    top: 0

  &.is-right
    right: 0

  &.is-bottom
    bottom: 0

  &.is-left
    left: 0

  .alert
    margin-bottom: 10px

// .alerts-enter-active, .list-leave-active
// transition: all 1s

// .alerts-enter, .alerts-leave-to
// opacity: 0
// transform: translateX(-200vw)

// .alerts-move
// transition: transform 1s
.alerts-enter-active, .alerts-leave-active
  transition: opacity 0.4s, transform 0.4s

.alerts-enter, .alerts-leave-active
  opacity: 0
  transform: translateX(300px)

.app-root
  padding: 80px
  height: 100vh
  width: 100%

#main
  height: 100%
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center

.container
  height: 100%
  display: flex
  flex-direction: column
  justify-content: center

</style>
